import api from './api';

export const getAccountSettings = async () => {
  const response = await api.get('/settings');
  return response.data;
};

export const uploadLogo = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await api.post('/settings/logo', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  
  return response.data;
};

export const updateTheme = async (theme) => {
  const response = await api.put('/settings/theme', theme);
  return response.data;
};

export const getAppConfig = async () => {
  const response = await api.get('/settings/config');
  return response.data;
};